const IconArrowRight = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
            <path d="M14.212 11.579a1 1 0 1 1 0-2h7.542a1 1 0 0 1 1 1v7.542a1 1 0 1 1-2 0v-5.128l-9.135 9.135a1 1 0 1 1-1.414-1.414l9.135-9.135h-5.128Z" />
        </svg>
    );
};

export default IconArrowRight;
